import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueCompositionApi from '@vue/composition-api';
import * as filters from './utils/filters';

import '@/styles/stylesheet.scss';

Vue.config.productionTip = false;
Vue.use(VueCompositionApi);

declare module '@vue/composition-api' {
  interface SetupContext {
    readonly refs: { [key: string]: Vue | Element | Vue[] | Element[] };
  }
}


Object.keys(filters).forEach(key => {
  // @ts-ignore
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
